import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8">
          <div className="md:col-span-4">
            <h2 className="text-2xl md:text-3xl font-heading font-bold tracking-tight mb-4">
              韩国漫画网
            </h2>
            <p className="text-background-50/70 text-sm leading-relaxed max-w-sm">
              韩国漫画网提供免费的漫画在线阅读和高清韩漫大全，资源丰富分类明确，加载流畅无需等待，是您发现和欣赏优质漫画的首选平台。
            </p>
          </div>

          <div className="md:col-span-3">
            <h3 className="text-xs font-label uppercase tracking-wider text-background-50/50 mb-5">
              快速导航
            </h3>
            <div className="flex flex-col gap-3">
              <Link to="/" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap">
                首页推荐
              </Link>
              <Link to="/category/romance" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap">
                分类浏览
              </Link>
              <Link to="/category/action" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap">
                热门排行
              </Link>
              <Link to="/about" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap">
                关于我们
              </Link>
            </div>
          </div>

          <div className="md:col-span-3">
            <h3 className="text-xs font-label uppercase tracking-wider text-background-50/50 mb-5">
              热门分类
            </h3>
            <div className="flex flex-col gap-3">
              <Link to="/category/romance" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap">
                恋爱漫画
              </Link>
              <Link to="/category/action" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap">
                热血漫画
              </Link>
              <Link to="/category/fantasy" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap">
                奇幻漫画
              </Link>
              <Link to="/category/urban" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap">
                都市漫画
              </Link>
            </div>
          </div>

          <div className="md:col-span-2">
            <h3 className="text-xs font-label uppercase tracking-wider text-background-50/50 mb-5">
              关注我们
            </h3>
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 rounded-full border border-background-50/20 flex items-center justify-center hover:bg-background-50/10 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-lg text-background-50/70"></i>
              </a>
              <a href="#" className="w-10 h-10 rounded-full border border-background-50/20 flex items-center justify-center hover:bg-background-50/10 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-lg text-background-50/70"></i>
              </a>
              <a href="#" className="w-10 h-10 rounded-full border border-background-50/20 flex items-center justify-center hover:bg-background-50/10 transition-colors cursor-pointer" aria-label="B站">
                <i className="ri-bilibili-line text-lg text-background-50/70"></i>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-background-50/10 mx-4 md:mx-6"></div>

      <div className="flex flex-col sm:flex-row items-center justify-between px-4 md:px-6 py-5 gap-3">
        <p className="text-xs text-background-50/40 whitespace-nowrap">
          &copy; 2026 韩国漫画网. All rights reserved.
        </p>
        <div className="flex items-center gap-5">
          <a href="#" className="text-xs text-background-50/40 hover:text-background-50/60 transition-colors whitespace-nowrap" rel="nofollow">
            隐私政策
          </a>
          <a href="#" className="text-xs text-background-50/40 hover:text-background-50/60 transition-colors whitespace-nowrap" rel="nofollow">
            服务条款
          </a>
          <a href="#" className="text-xs text-background-50/40 hover:text-background-50/60 transition-colors whitespace-nowrap" rel="nofollow">
            版权声明
          </a>
        </div>
      </div>
    </footer>
  );
}